import { MAPPING_STATUS, MAX_MAPPING_TEXT_LENGTH } from 'constants/mapping';

export const setEditedItemsWithChecked = ({
  key,
  updatedData,
  checkedItems,
  setEditedItems,
  editedItems,
}) => {
  const newEditedItems = {};
  if (checkedItems[key]) {
    Object.keys(checkedItems)
      .filter(rowKey => rowKey !== 'control')
      .forEach(checkedKey => {
        newEditedItems[checkedKey] = { ...editedItems[checkedKey], ...updatedData };
      });
  } else {
    newEditedItems[key] = { ...editedItems[key], ...updatedData };
  }
  setEditedItems({ ...editedItems, ...newEditedItems });
};

export const setAppMenuWithChecked = ({
  key,
  itemType,
  updatedData,
  checkedItems,
  setAppMenu,
  appMenu,
}) => {
  const newEditedItems = appMenu[itemType];
  if (checkedItems[key]) {
    Object.keys(checkedItems)
      .filter(rowKey => rowKey !== 'control')
      .forEach(checkedKey => {
        newEditedItems[checkedKey] = { ...newEditedItems[checkedKey], ...updatedData };
      });
  } else {
    newEditedItems[key] = { ...appMenu[itemType][key], ...updatedData };
  }
  setAppMenu({
    ...appMenu,
    ...{
      [itemType]: { ...appMenu[itemType], ...newEditedItems },
    },
  });
};

export const renderArrayCell = array => {
  if (!array) return '';
  const text = array.join(', ');
  return text.length > MAX_MAPPING_TEXT_LENGTH
    ? `${text.slice(0, MAX_MAPPING_TEXT_LENGTH)}...`
    : text;
};

export const setSelectedValue = ({
  rowKey,
  value,
  appMenu,
  itemType,
  checkedItems,
  setEditedItems,
  editedItems,
  setAppMenu,
}) => {
  // set edited item to be sent to the BE on save & update state
  setEditedItemsWithChecked({
    key: rowKey,
    updatedData: {
      uuidExternalId: value,
      externalIdMapping: value,
    },
    checkedItems,
    setEditedItems,
    editedItems,
  });
  setAppMenuWithChecked({
    key: rowKey,
    itemType,
    updatedData: {
      uuidExternalId: value,
      externalIdMapping: value,
      mappingStatus: value ? MAPPING_STATUS.STAGED_MAPPED : MAPPING_STATUS.STAGED_UNMAPPED,
    },
    checkedItems,
    setAppMenu,
    appMenu,
  });
};

export const uniqueParentsFilter = ({ fieldName, appMenu, itemType }) => {
  if (!appMenu[itemType]) return [];
  const parents = new Set();
  Object.values(appMenu[itemType]).forEach(item => {
    if (!item[fieldName]) return;
    item[fieldName].forEach(parent => {
      if (!parents.has(parent)) {
        parents.add(parent);
      }
    });
  });
  const choices = Array.from(parents).map(parent => ({ text: parent, value: parent }));
  return choices;
};
